var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shift-condition-edit',
  created () {
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      conditions: {
        shop_id: window.localStorage.getItem('shop_id'),
        time_limit: null,
        monday_shift_class_id: null,
        tuesday_shift_class_id: null,
        wednesday_shift_class_id: null,
        thursday_shift_class_id: null,
        friday_shift_class_id: null,
        saturday_shift_class_id: null,
        sunday_shift_class_id: null,
        holiday_shift_class_id: null
      }
    }
  },
  computed: {
    shiftConditionEdit () {
      return this.$store.getters.shiftConditionEdit
    },
    shiftClassesAll () {
      return this.$store.getters.shiftClassesAll
    },
    shiftConditionUser () {
      return this.$store.getters.shiftConditionUser
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      var data = {'shop_id': window.localStorage.getItem('shop_id')}
      var self = this
      var callback = function () {
        if (self.shiftConditionEdit != null) {
          self.conditions.time_limit = self.shiftConditionEdit.time_limit,
          self.conditions.monday_shift_class_id = self.shiftConditionEdit.monday_shift_class_id,
          self.conditions.tuesday_shift_class_id = self.shiftConditionEdit.tuesday_shift_class_id,
          self.conditions.wednesday_shift_class_id = self.shiftConditionEdit.wednesday_shift_class_id,
          self.conditions.thursday_shift_class_id = self.shiftConditionEdit.thursday_shift_class_id,
          self.conditions.friday_shift_class_id = self.shiftConditionEdit.friday_shift_class_id,
          self.conditions.saturday_shift_class_id = self.shiftConditionEdit.saturday_shift_class_id,
          self.conditions.sunday_shift_class_id = self.shiftConditionEdit.sunday_shift_class_id,
          self.conditions.holiday_shift_class_id = self.shiftConditionEdit.holiday_shift_class_id
        }
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('SHIFT_CONDITION_EDIT', { id: this.$route.params.id, data: data, callback: callback })
    },
    onClickSave: function() {
      var data = {}
      data = this.conditions
      this.$store.dispatch('SHIFT_CONDITION_UPDATE', { data: data, callback: this.onSaved, user_id: this.$route.params.id })
    },
    onSaved: function() {
      this.$router.push('/shift_condition')
    },
    onClickCancel: function() {
      this.$router.push('/shift_condition')
    },
    timeCheck() {
      if (this.conditions.time_limit) {
        if (!this.isNumerical(this.conditions.time_limit)) {
          return true
        } else if (this.conditions.time_limit < 1000 && this.conditions.time_limit > 0) {
          return false
        }
      } else {
        return false
      }
      return true
    },
    isNumerical: function(val) {
      if (!val) return true
      return utils.regex.numerical.test(val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-condition-edit.js